/* eslint-disable */
export interface paths {
    "/customer/api/tcd/api-keys": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get all API keys
         * @description Retrieves a paginated list of all API keys for the current organization user.
         */
        get: operations["OrganizationUserApiKeyController_getMany"];
        put?: never;
        /**
         * Create an API key
         * @description Creates a new API key for the current organization user.
         */
        post: operations["OrganizationUserApiKeyController_create"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customer/api/tcd/api-keys/{apiKey}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Update an API key
         * @description Updates the status of an existing API key.
         */
        patch: operations["OrganizationUserApiKeyController_update"];
        trace?: never;
    };
    "/customer/api/tcd/api-keys/schema/download": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Download the API key integration schema
         * @description Downloads the API key integration schema.
         */
        get: operations["OrganizationUserApiKeyController_downloadApiKeyIntegrationSchema"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customer/api/tcd/users/invitations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get all organization user invitations
         * @description Retrieves a paginated list of invitations for the organization. Can be filtered by status, email, and expiry.
         */
        get: operations["OrganizationUserInvitationController_getMany"];
        put?: never;
        /**
         * Create an organization user invitation
         * @description Creates an invitation for a user to join the organization. An invitation email will be sent.
         */
        post: operations["OrganizationUserInvitationController_create"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customer/api/tcd/users/invitations/{id}/cancel": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Cancel an organization user invitation
         * @description Cancels a pending invitation for a user to join the organization.
         */
        post: operations["OrganizationUserInvitationController_cancel"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customer/api/tcd/users/invitations/{id}/resend": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Resend an organization user invitation
         * @description Resend the invitation email for a pending invitation, refreshing the token and expiry.
         */
        post: operations["OrganizationUserInvitationController_resend"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customer/api/tcd/users/invitations/{token}/validate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Validate an organization user invitation
         * @description Validates an invitation token after clicking on the link in the invitation email.
         */
        post: operations["OrganizationUserInvitationController_validate"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customer/api/tcd/users/invitations/{token}/accept": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Accept an organization user invitation
         * @description Accepts an invitation to join the organization. Creates the user account with the provided information.
         */
        post: operations["OrganizationUserInvitationController_accept"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customer/api/tcd/teams": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get all organization teams
         * @description Retrieves a paginated list of all teams in the organization.
         */
        get: operations["OrganizationTeamController_getMany"];
        put?: never;
        /**
         * Create an organization team
         * @description Creates a new team within the organization.
         */
        post: operations["OrganizationTeamController_create"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customer/api/tcd/teams/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get an organization team by ID
         * @description Retrieves detailed information about a specific team by its ID.
         */
        get: operations["OrganizationTeamController_get"];
        put?: never;
        post?: never;
        /**
         * Delete an organization team
         * @description Deletes a team from the organization by ID.
         */
        delete: operations["OrganizationTeamController_delete"];
        options?: never;
        head?: never;
        /**
         * Update an organization team
         * @description Updates a team within the organization by ID.
         */
        patch: operations["OrganizationTeamController_update"];
        trace?: never;
    };
    "/customer/api/tcd/users": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get all organization users
         * @description Retrieves a paginated list of all users in the organization. Can be filtered by email.
         */
        get: operations["OrganizationUserController_getMany"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customer/api/tcd/users/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Update an organization user
         * @description Updates an existing user's role and status in the organization.
         */
        patch: operations["OrganizationUserController_update"];
        trace?: never;
    };
    "/customer/api/tcd/users/change-requests": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get all organization user change requests
         * @description Retrieves a paginated list of change requests for the organization. Admin only.
         */
        get: operations["OrganizationUserChangeRequestController_getMany"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customer/api/tcd/me": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get current user information
         * @description Retrieves the authenticated user's profile information.
         */
        get: operations["MeController_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Update current user information
         * @description Updates the authenticated user's profile information.
         */
        patch: operations["MeController_update"];
        trace?: never;
    };
    "/customer/api/tcd/me/login": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Record user login
         * @description Records the current timestamp as the last login time for the authenticated user.
         */
        post: operations["MeController_login"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customer/api/tcd/organizations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get organization
         * @description Retrieves the authenticated user's organization information.
         */
        get: operations["OrganizationController_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customer/api/tcd/files/{type}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Upload a file
         * @description Uploads a file (content, NPI, or avatar) to the system. The file type determines validation rules.
         */
        post: operations["CustomerFileController_upload"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customer/api/tcd/campaign-requests/{id}/submit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Submit a campaign request to review
         * @description Submits a campaign request to review by ID.
         */
        post: operations["CampaignRequestController_submit"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customer/api/tcd/campaign-requests/{id}/archive": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Archive or unarchive a campaign request
         * @description Archives or un archives a campaign request by ID.
         */
        post: operations["CampaignRequestController_archive"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customer/api/tcd/campaign-requests": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get many campaign requests
         * @description Retrieves many campaign requests.
         */
        get: operations["CampaignRequestController_getMany"];
        put?: never;
        /**
         * Create a campaign request
         * @description Creates a new campaign request.
         */
        post: operations["CampaignRequestController_create"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customer/api/tcd/campaign-requests/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a campaign request by ID
         * @description Retrieves a campaign request by its ID.
         */
        get: operations["CampaignRequestController_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Update a campaign request
         * @description Updates an existing campaign request by ID.
         */
        patch: operations["CampaignRequestController_update"];
        trace?: never;
    };
    "/customer/api/tcd/campaign-requests/check-duplicate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Check for a duplicate campaign request field
         * @description Checks whether a campaign request with the given field value already exists within the organization.
         */
        get: operations["CampaignRequestController_checkDuplicate"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customer/api/tcd/programs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get programs
         * @description Retrieves programs for the organization.
         */
        get: operations["CampaignRequestProgramController_getMany"];
        put?: never;
        /**
         * Create a program
         * @description Creates a new program.
         */
        post: operations["CampaignRequestProgramController_create"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customer/api/tcd/programs/check-duplicate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Check for a duplicate program
         * @description Checks whether a program with the given field value already exists in the organization.
         */
        get: operations["CampaignRequestProgramController_checkDuplicate"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customer/api/tcd/programs/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a program
         * @description Retrieves a program by ID.
         */
        get: operations["CampaignRequestProgramController_getOne"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Update a program
         * @description Updates a program by ID.
         */
        patch: operations["CampaignRequestProgramController_update"];
        trace?: never;
    };
    "/customer/api/tcd/programs/{id}/stage": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Change the program stage
         * @description Transitions the program to a new stage.
         */
        post: operations["CampaignRequestProgramController_changeStage"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customer/api/tcd/programs/{id}/campaign-requests/{campaignRequestId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Link a campaign request to a program
         * @description Links an existing campaign request to the program. Idempotent.
         */
        put: operations["CampaignRequestProgramController_linkCampaignRequest"];
        post?: never;
        /**
         * Unlink a campaign request from a program
         * @description Unlinks a campaign request from the program.
         */
        delete: operations["CampaignRequestProgramController_unlinkCampaignRequest"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customer/api/tcd/campaign-requests/{id}/edits": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get many campaign request edits
         * @description Retrieves many campaign request edits.
         */
        get: operations["CampaignRequestEditController_getMany"];
        put?: never;
        /**
         * Create a campaign request edit
         * @description Creates a new campaign request edit.
         */
        post: operations["CampaignRequestEditController_create"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customer/api/tcd/campaign-requests/edits/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a campaign request edit by ID
         * @description Retrieves a campaign request edit by its ID.
         */
        get: operations["CampaignRequestEditController_get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Update a campaign request edit
         * @description Updates a campaign request edit.
         */
        patch: operations["CampaignRequestEditController_update"];
        trace?: never;
    };
    "/customer/api/tcd/campaign-requests/edits/{id}/cancel": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Cancel a campaign request edit
         * @description Cancels a campaign request edit while it is under review.
         */
        post: operations["CampaignRequestEditController_cancel"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customer/api/tcd/campaign-requests/{id}/comments": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get campaign request comments
         * @description Retrieves campaign request comments.
         */
        get: operations["CampaignRequestCommentController_getMany"];
        put?: never;
        /**
         * Create a campaign request comment
         * @description Creates a new campaign request comment.
         */
        post: operations["CampaignRequestCommentController_create"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customer/api/tcd/campaign-requests/{id}/comments/open": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Open campaign request comments
         * @description Opens campaign request comments.
         */
        post: operations["CampaignRequestCommentController_open"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customer/api/tcd/campaign-requests/comments/{commentId}/reactions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * React to a campaign request comment
         * @description Toggles the current user's reaction on a campaign request comment.
         */
        post: operations["CampaignRequestCommentReactionController_react"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customer/api/tcd/report-types": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get many organization reports
         * @description Retrieves a paginated list of all reports for the authenticated user's organization.
         */
        get: operations["ReportController_getManyTypes"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customer/api/tcd/reports/files": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Download a report
         * @description Downloads a report for the authenticated user's organization.
         */
        get: operations["ReportController_download"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customer/api/tcd/reports": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get many organization reports
         * @description Retrieves a paginated list of all reports for the authenticated user's organization.
         */
        get: operations["ReportController_getMany"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customer/api/tcd/users/password-strength": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Validate password strength
         * @description Returns a password strength score with feedback.
         */
        post: operations["PasswordStrengthController_validate"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customer/api/tcd/audit-logs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get audit logs
         * @description Retrieves audit logs for the organization.
         */
        get: operations["CustomerAuditLogController_getMany"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customer/api/tcd/campaign-requests/{id}/audit-logs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get audit logs for a campaign request
         * @description Retrieves audit logs for a campaign request by ID.
         */
        get: operations["CustomerAuditLogController_getCampaignRequestAuditLogs"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customer/api/tcd/programs/{id}/audit-logs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get audit logs for a program
         * @description Retrieves audit logs for a program by ID.
         */
        get: operations["CustomerAuditLogController_getCampaignRequestProgramAuditLogs"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        ApiErrorDto: {
            /**
             * @description HTTP status code
             * @example 400
             */
            status: number;
            /**
             * @description Error message
             * @example Bad Request
             */
            message?: string | string[];
            /**
             * @description Error name
             * @example BadRequestException
             */
            error?: string;
        };
        CreateOrganizationUserApiKeyDto: {
            /**
             * @description The name of the API key
             * @example Production API Key
             */
            name?: string | null;
            /**
             * Format: date-time
             * @description The expiration date of the API key
             * @example 2026-07-15T10:30:00.000Z
             */
            expiresAt: string;
        };
        /**
         * @description The status of the API key
         * @enum {number}
         */
        OrganizationUserApiKeyStatusEnum: OrganizationUserApiKeyStatusEnum;
        OrganizationUserApiKeyResponseDto: {
            /**
             * @description The name of the API key
             * @example Production API Key
             */
            name?: string | null;
            /**
             * @description The API key value only available for creation
             * @example tmdc_ak_...
             */
            apiKey: string;
            /**
             * @description The secret key value only available for creation
             * @example tmdc_sk_...
             */
            secretKey?: string;
            /**
             * @description The status of the API key
             * @example 1
             */
            status: components["schemas"]["OrganizationUserApiKeyStatusEnum"];
            /**
             * Format: date-time
             * @description The date the API key was created
             * @example 2026-01-15T10:30:00.000Z
             */
            createdAt: string;
            /**
             * Format: date-time
             * @description The date the API key expires
             * @example 2026-07-15T10:30:00.000Z
             */
            expiresAt: string;
            /**
             * Format: date-time
             * @description The date the API key was last used
             * @example 2026-03-25T10:30:00.000Z
             */
            lastUsedAt?: string;
        };
        ManyOrganizationUserApiKeysResponseDto: {
            /** @description Items */
            items: components["schemas"]["OrganizationUserApiKeyResponseDto"][];
            /**
             * @description Total count
             * @example 100
             */
            totalCount: number;
            /**
             * @description Has next page
             * @example true
             */
            hasNextPage: boolean;
            /**
             * @description Has previous page
             * @example true
             */
            hasPreviousPage: boolean;
            /**
             * @description Total pages
             * @example 10
             */
            totalPages: number;
        };
        UpdateOrganizationUserApiKeyDto: {
            /**
             * @description The name of the API key
             * @example Production API Key
             */
            name?: string | null;
            /**
             * @description The status of the API key
             * @example 0
             * @enum {number}
             */
            status: UpdateOrganizationUserApiKeyDtoStatus;
        };
        StreamableFile: Record<string, never>;
        /** @enum {number} */
        OrganizationUserInvitationStatusEnum: OrganizationUserInvitationStatusEnum;
        /**
         * @description The role the invited user will have
         * @enum {number}
         */
        OrganizationUserRoleEnum: OrganizationUserRoleEnum;
        OrganizationUserInvitationResponseDto: {
            /**
             * @description The id of the invitation
             * @example a1b2c3d4-e5f6-4a7b-8c9d-0e1f2a3b4c5d
             */
            id: string;
            /**
             * @description The invited email address
             * @example jane@acme.com
             */
            email: string;
            /**
             * @description The role the invited user will have
             * @example 2
             */
            role: components["schemas"]["OrganizationUserRoleEnum"];
            /**
             * @description The status of the invitation
             * @example 0
             */
            status: components["schemas"]["OrganizationUserInvitationStatusEnum"];
            /**
             * @description When the invitation token expires
             * @example 2026-03-17T10:00:00.000Z
             */
            expiresAt: string;
            /**
             * @description When the invitation was created
             * @example 2026-03-10T10:00:00.000Z
             */
            createdAt: string;
        };
        ManyOrganizationUserInvitationsResponseDto: {
            /** @description Items */
            items: components["schemas"]["OrganizationUserInvitationResponseDto"][];
            /**
             * @description Total count
             * @example 100
             */
            totalCount: number;
            /**
             * @description Has next page
             * @example true
             */
            hasNextPage: boolean;
            /**
             * @description Has previous page
             * @example true
             */
            hasPreviousPage: boolean;
            /**
             * @description Total pages
             * @example 10
             */
            totalPages: number;
        };
        CreateOrganizationUserInvitationDto: {
            /**
             * @description The email of the user to invite
             * @example jane@acme.com
             */
            email: string;
            /**
             * @description The role to assign on acceptance
             * @example 1
             */
            role: components["schemas"]["OrganizationUserRoleEnum"];
        };
        ValidateOrganizationUserInvitationResponseDto: {
            /**
             * @description The email of the user
             * @example john.doe@example.com
             */
            email: string;
        };
        AcceptOrganizationUserInvitationDto: {
            /**
             * @description First Name
             * @example John
             */
            firstName: string;
            /**
             * @description Last Name
             * @example Doe
             */
            lastName: string;
            /**
             * @description Timezone
             * @example America/New_York
             */
            timezone: string;
            /**
             * @description Password
             * @example SecureP@ss123
             */
            password: string;
        };
        CreateOrganizationTeamDto: {
            /**
             * @description The name of the team
             * @example Marketing Team
             */
            name: string;
        };
        CreateOrganizationTeamResponseDto: {
            /**
             * @description Team ID
             * @example 1
             */
            id: number;
        };
        UpdateOrganizationTeamDto: {
            /**
             * @description The name of the team
             * @example Marketing Team
             */
            name: string;
        };
        OrganizationTeamResponseDto: {
            /**
             * @description Team ID
             * @example 1
             */
            id: number;
            /**
             * @description Team name
             * @example Marketing Team
             */
            name: string;
            /**
             * Format: date-time
             * @description Team creation date
             * @example 2026-01-01T00:00:00.000Z
             */
            createdAt: string;
            /**
             * Format: date-time
             * @description Team last update date
             * @example 2026-01-15T10:30:00.000Z
             */
            updatedAt: string;
        };
        ManyOrganizationTeamsResponseDto: {
            /** @description Items */
            items: components["schemas"]["OrganizationTeamResponseDto"][];
            /**
             * @description Total count
             * @example 100
             */
            totalCount: number;
            /**
             * @description Has next page
             * @example true
             */
            hasNextPage: boolean;
            /**
             * @description Has previous page
             * @example true
             */
            hasPreviousPage: boolean;
            /**
             * @description Total pages
             * @example 10
             */
            totalPages: number;
        };
        /**
         * @description The status of the user
         * @enum {number}
         */
        OrganizationUserStatusEnum: OrganizationUserStatusEnum;
        /**
         * @description File type
         * @enum {number}
         */
        CustomerFileTypeEnum: CustomerFileTypeEnum;
        CustomerFileResponseDto: {
            /**
             * @description File ID
             * @example a1b2c3d4-e5f6-7890-abcd-ef1234567890
             */
            id: string;
            /**
             * @description File URL
             * @example https://storage.example.com/files/content-file.csv
             */
            url: string;
            /**
             * @description File name
             * @example content-file.csv
             */
            name: string;
            /**
             * Format: date-time
             * @description File creation date
             * @example 2026-01-15T10:30:00.000Z
             */
            createdAt: string;
            /**
             * @description File type
             * @example 0
             */
            type: components["schemas"]["CustomerFileTypeEnum"];
            /**
             * @description File size in bytes
             * @example 1000
             */
            size: number;
        };
        /**
         * @description The type of the change request
         * @enum {number}
         */
        OrganizationUserChangeRequestTypeEnum: OrganizationUserChangeRequestTypeEnum;
        /**
         * @description The status of the change request
         * @enum {number}
         */
        OrganizationUserChangeRequestStatusEnum: OrganizationUserChangeRequestStatusEnum;
        PendingOrganizationUserChangeRequestResponseDto: {
            /**
             * @description The type of the change request
             * @example 1
             */
            type: components["schemas"]["OrganizationUserChangeRequestTypeEnum"];
            /**
             * @description The status of the change request
             * @example 0
             */
            status: components["schemas"]["OrganizationUserChangeRequestStatusEnum"];
            /** @description The payload of the change request */
            payload?: Record<string, never> | null;
            /**
             * @description The date the change request was created
             * @example 2026-01-01T00:00:00.000Z
             */
            createdAt: string;
        };
        OrganizationUserResponseDto: {
            /**
             * @description The id of the user
             * @example c3d4e5f6-a7b8-9012-cdef-123456789012
             */
            id: string;
            /**
             * @description The email of the user
             * @example john.doe@example.com
             */
            email: string;
            /**
             * @description The role of the user
             * @example 0
             */
            role: components["schemas"]["OrganizationUserRoleEnum"];
            /**
             * @description The first name of the user
             * @example John
             */
            firstName?: string | null;
            /**
             * @description The last name of the user
             * @example Doe
             */
            lastName?: string | null;
            /**
             * @description The status of the user
             * @example 1
             */
            status: components["schemas"]["OrganizationUserStatusEnum"];
            /**
             * @description The next status of the user
             * @example 0
             */
            nextStatus: components["schemas"]["OrganizationUserStatusEnum"];
            /**
             * Format: date-time
             * @description The date the user last logged in
             * @example 2026-03-25T10:30:00.000Z
             */
            lastLoginAt?: string;
            /**
             * @description The created at date
             * @example 2026-01-01T00:00:00.000Z
             */
            createdAt: string;
            /**
             * @description The updated at date
             * @example 2026-01-15T10:30:00.000Z
             */
            updatedAt: string;
            /** @description The avatar of the user */
            avatar?: components["schemas"]["CustomerFileResponseDto"];
            /** @description Pending change request for this user */
            pendingChangeRequest: components["schemas"]["PendingOrganizationUserChangeRequestResponseDto"];
        };
        ManyOrganizationUsersResponseDto: {
            /** @description Items */
            items: components["schemas"]["OrganizationUserResponseDto"][];
            /**
             * @description Total count
             * @example 100
             */
            totalCount: number;
            /**
             * @description Has next page
             * @example true
             */
            hasNextPage: boolean;
            /**
             * @description Has previous page
             * @example true
             */
            hasPreviousPage: boolean;
            /**
             * @description Total pages
             * @example 10
             */
            totalPages: number;
        };
        UpdateOrganizationUserDto: {
            /**
             * @description The role of the user
             * @example 1
             */
            role?: components["schemas"]["OrganizationUserRoleEnum"] | null;
            /**
             * @description Set the status to inactive to deactivate the user
             * @example 0
             */
            status?: components["schemas"]["OrganizationUserStatusEnum"];
        };
        UpdateOrganizationUserResponseDto: {
            /**
             * @description Whether the update created a change request pending approval instead of being applied directly.
             * @example false
             */
            pendingApproval: boolean;
        };
        UserResponseDto: {
            /**
             * @description User first name
             * @example Jane
             */
            firstName?: string | null;
            /**
             * @description User last name
             * @example Smith
             */
            lastName?: string | null;
            /**
             * @description User email
             * @example jane.smith@example.com
             */
            email: string;
            /**
             * @description User timezone
             * @example America/New_York
             */
            timezone?: string | null;
        };
        OrganizationUserChangeRequestResponseDto: {
            /**
             * @description The type of the change request
             * @example 1
             */
            type: components["schemas"]["OrganizationUserChangeRequestTypeEnum"];
            /**
             * @description The status of the change request
             * @example 0
             */
            status: components["schemas"]["OrganizationUserChangeRequestStatusEnum"];
            /** @description The payload of the change request */
            payload?: Record<string, never> | null;
            /** @description The target organization user for the change request */
            organizationUser?: components["schemas"]["OrganizationUserResponseDto"];
            /** @description The organization user who submitted the change request */
            requestedByOrganizationUser: components["schemas"]["OrganizationUserResponseDto"];
            /** @description The user who reviewed the change request */
            reviewedByUser?: components["schemas"]["UserResponseDto"];
            /** @description The reason for decline */
            declineReason?: string;
            /**
             * @description The date the change request was reviewed
             * @example 2026-01-15T10:30:00.000Z
             */
            reviewedAt?: string;
            /**
             * @description The date the change request was created
             * @example 2026-01-01T00:00:00.000Z
             */
            createdAt: string;
        };
        ManyOrganizationUserChangeRequestsResponseDto: {
            /** @description Items */
            items: components["schemas"]["OrganizationUserChangeRequestResponseDto"][];
            /**
             * @description Total count
             * @example 100
             */
            totalCount: number;
            /**
             * @description Has next page
             * @example true
             */
            hasNextPage: boolean;
            /**
             * @description Has previous page
             * @example true
             */
            hasPreviousPage: boolean;
            /**
             * @description Total pages
             * @example 10
             */
            totalPages: number;
        };
        /**
         * @description Permission action
         * @enum {string}
         */
        CustomerPermissionActionEnum: CustomerPermissionActionEnum;
        /**
         * @description Permission subject
         * @enum {string}
         */
        CustomerPermissionSubjectEnum: CustomerPermissionSubjectEnum;
        PermissionDto: {
            /**
             * @description Permission action
             * @example [
             *       "create",
             *       "read",
             *       "update"
             *     ]
             */
            actions: components["schemas"]["CustomerPermissionActionEnum"][];
            /**
             * @description Permission subject
             * @example campaignRequest
             */
            subject: components["schemas"]["CustomerPermissionSubjectEnum"];
        };
        /**
         * @description Feature flag
         * @enum {string}
         */
        FeatureEnum: FeatureEnum;
        FeatureFlagDto: {
            /**
             * @description Feature flag
             * @example campaignRequestProgram
             */
            feature: components["schemas"]["FeatureEnum"];
            /** @description Feature flag enabled */
            enabled: boolean;
        };
        MeResponseDto: {
            /**
             * @description User id
             * @example c3d4e5f6-a7b8-9012-cdef-123456789012
             */
            id: string;
            /**
             * @description User email
             * @example john.doe@example.com
             */
            email: string;
            /**
             * @description User first name
             * @example John
             */
            firstName: string;
            /**
             * @description User last name
             * @example Doe
             */
            lastName: string;
            /**
             * @description User timezone
             * @example America/New_York
             */
            timezone: string;
            /**
             * @description User role
             * @example 0
             */
            role: components["schemas"]["OrganizationUserRoleEnum"];
            /** @description User avatar */
            avatar?: components["schemas"]["CustomerFileResponseDto"];
            /**
             * Format: date-time
             * @description The date the user last logged in
             * @example 2026-03-25T10:30:00.000Z
             */
            lastLoginAt?: string;
            /**
             * Format: date-time
             * @description User created at
             * @example 2026-01-01T00:00:00.000Z
             */
            createdAt: string;
            /** @description User permissions */
            permissions: components["schemas"]["PermissionDto"][];
            /** @description Feature flags */
            featureFlags: components["schemas"]["FeatureFlagDto"][];
        };
        UpdateMeDto: {
            /**
             * @description The first name of the user
             * @example John
             */
            firstName?: string;
            /**
             * @description The last name of the user
             * @example Doe
             */
            lastName?: string;
            /**
             * @description The email of the user
             * @example john.doe@example.com
             */
            email?: string;
            /**
             * @description The timezone of the user
             * @example America/New_York
             */
            timezone?: string;
            /**
             * @description The avatar id of the user
             * @example a1b2c3d4-e5f6-7890-abcd-ef1234567890
             */
            avatarId?: string | null;
        };
        /**
         * @description Access control modules
         * @enum {number}
         */
        OrganizationAccessControlModuleEnum: OrganizationAccessControlModuleEnum;
        OrganizationResponseDto: {
            /**
             * @description Organization name
             * @example Acme Healthcare Inc.
             */
            name: string;
            /** @description Account manager */
            accountManager?: components["schemas"]["UserResponseDto"];
            /** @description When the account manager is on leave, the organization member who temporarily covers their responsibilities */
            coverageMember?: components["schemas"]["UserResponseDto"];
            /**
             * @description End date (inclusive) of account manager leave coverage; ISO 8601 timestamp
             * @example 2026-03-20T23:59:59.999Z
             */
            coverageMemberEndDate?: string;
            /**
             * @description Access control modules
             * @example [
             *       0
             *     ]
             */
            accessControlModules?: components["schemas"]["OrganizationAccessControlModuleEnum"][];
        };
        UploadFileDto: {
            /**
             * Format: binary
             * @description The file to be uploaded
             */
            file: string;
        };
        ArchiveCampaignRequestDto: {
            /**
             * @description Whether to archive or unarchive the campaign request
             * @example true
             */
            archived: boolean;
        };
        /**
         * @description Campaign pricing type. Defaults to `CPC`.
         * @enum {number}
         */
        CampaignTypeEnum: CampaignTypeEnum;
        /**
         * @description Budget distribution strategy. One of `EVENLY`, `FRONT_LOADED`, `MONTHLY`.
         * @enum {number}
         */
        CampaignRequestDistributionEnum: CampaignRequestDistributionEnum;
        /**
         * @description 0 is the only acceptable value.
         * @enum {number}
         */
        CreativeTypeEnum: CreativeTypeEnum;
        /**
         * @description Targeting type for the campaign. One of `NPI`, `GEO`, `SPECIALTY`, `SPECIALTY_AUTH`, `RON`.
         * @enum {number}
         */
        CampaignRequestTargetingTypeEnum: CampaignRequestTargetingTypeEnum;
        CreateCampaignRequestDto: {
            /**
             * @description Campaign name
             * @example Summer Health Campaign 2026
             */
            campaignName: string;
            /**
             * @description Campaign pricing type. Defaults to `CPC`.
             * @default 0
             * @example 0
             */
            campaignType: components["schemas"]["CampaignTypeEnum"];
            /**
             * Format: date
             * @description Campaign's start date as an ISO 8601 calendar date (YYYY-MM-DD). No time component. Interpreted in the request's timezone. Must be in the future.
             * @example 2026-03-01
             */
            startDate?: string;
            /**
             * Format: date
             * @description Campaign's end date as an ISO 8601 calendar date (YYYY-MM-DD). No time component. Interpreted in the request's timezone. Must be after startDate.
             * @example 2026-06-30
             */
            endDate?: string;
            /**
             * @description IANA timezone name for interpreting startDate and endDate
             * @example America/New_York
             */
            timezone?: string;
            /**
             * @description Total campaign budget in USD cents. Min 1.
             * @example 500000
             */
            totalBudget?: number;
            /**
             * @description Cost in USD cents. Per click for CPC.
             * @example 300
             */
            cost?: number;
            /**
             * @description Budget distribution strategy. One of `EVENLY`, `FRONT_LOADED`, `MONTHLY`.
             * @example 0
             */
            distribution?: components["schemas"]["CampaignRequestDistributionEnum"];
            /**
             * @description Required and accepted only when distribution is MONTHLY. Must include all months between startDate and endDate.
             * @example {
             *       "2026-03": 150000,
             *       "2026-04": 175000,
             *       "2026-05": 175000
             *     }
             */
            monthlyBudget?: {
                [key: string]: number;
            };
            /**
             * @description ID of the campaign in the caller's system.
             * @example CAMP-2026-001
             */
            customId?: string;
            /**
             * @description 0 is the only acceptable value.
             * @example 0
             */
            creativeType?: components["schemas"]["CreativeTypeEnum"];
            /**
             * Format: uuid
             * @description The UUID returned from POST /files/0
             * @example a1b2c3d4-e5f6-7890-abcd-ef1234567890
             */
            creativeFileId?: string;
            /**
             * @description Targeting type for the campaign. One of `NPI`, `GEO`, `SPECIALTY`, `SPECIALTY_AUTH`, `RON`.
             * @example 0
             */
            targetingType?: components["schemas"]["CampaignRequestTargetingTypeEnum"];
            /**
             * Format: uuid
             * @description The UUID returned from POST /files/1. Required if targetingType is NPI
             * @example b2c3d4e5-f6a7-8901-bcde-f12345678901
             */
            npiFileId?: string;
            /**
             * @description Specialty targeting value. Required when `targetingType` is `SPECIALTY` or `SPECIALTY_AUTH`. Max 255.
             * @example Cardiology
             */
            specialtyTargeting?: string;
            /**
             * @description Geographic targeting value. Required when `targetingType` is `GEO`, `SPECIALTY` or `SPECIALTY_AUTH`. Max 255.
             * @example US-CA,US-NY
             */
            geoTargeting?: string;
            /**
             * Format: uuid
             * @description UUID of the campaign owner user. Defaults to API key owner. Must belong to the caller's organization.
             * @example c3d4e5f6-a7b8-9012-cdef-123456789012
             */
            ownerUserId?: string;
            /**
             * @description ID of the team. To get this value, retrieve teams. Must belong to the caller's organization. Min 1.
             * @example 1
             */
            teamId?: number;
        };
        CreateCampaignRequestResponseDto: {
            /**
             * @description The ID of the campaign request
             * @example 1
             */
            id: number;
        };
        UpdateCampaignRequestDto: {
            /**
             * @description Campaign name
             * @example Summer Health Campaign 2026
             */
            campaignName?: string;
            /**
             * Format: date
             * @description Campaign's start date as an ISO 8601 calendar date (YYYY-MM-DD). No time component. Interpreted in the request's timezone. Must be in the future.
             * @example 2026-03-01
             */
            startDate?: string;
            /**
             * Format: date
             * @description Campaign's end date as an ISO 8601 calendar date (YYYY-MM-DD). No time component. Interpreted in the request's timezone. Must be after startDate.
             * @example 2026-06-30
             */
            endDate?: string;
            /**
             * @description IANA timezone name for interpreting startDate and endDate
             * @example America/New_York
             */
            timezone?: string;
            /**
             * @description Total campaign budget in USD cents. Min 1.
             * @example 500000
             */
            totalBudget?: number;
            /**
             * @description Cost in USD cents. Per click for CPC.
             * @example 300
             */
            cost?: number;
            /**
             * @description Budget distribution strategy. One of `EVENLY`, `FRONT_LOADED`, `MONTHLY`.
             * @example 0
             */
            distribution?: components["schemas"]["CampaignRequestDistributionEnum"];
            /**
             * @description Required and accepted only when distribution is MONTHLY. Must include all months between startDate and endDate.
             * @example {
             *       "2026-03": 150000,
             *       "2026-04": 175000,
             *       "2026-05": 175000
             *     }
             */
            monthlyBudget?: {
                [key: string]: number;
            };
            /**
             * @description ID of the campaign in the caller's system.
             * @example CAMP-2026-001
             */
            customId?: string;
            /**
             * @description 0 is the only acceptable value.
             * @example 0
             */
            creativeType?: components["schemas"]["CreativeTypeEnum"];
            /**
             * Format: uuid
             * @description The UUID returned from POST /files/0
             * @example a1b2c3d4-e5f6-7890-abcd-ef1234567890
             */
            creativeFileId?: string;
            /**
             * @description Targeting type for the campaign. One of `NPI`, `GEO`, `SPECIALTY`, `SPECIALTY_AUTH`, `RON`.
             * @example 0
             */
            targetingType?: components["schemas"]["CampaignRequestTargetingTypeEnum"];
            /**
             * Format: uuid
             * @description The UUID returned from POST /files/1. Required if targetingType is NPI
             * @example b2c3d4e5-f6a7-8901-bcde-f12345678901
             */
            npiFileId?: string;
            /**
             * @description Specialty targeting value. Required when `targetingType` is `SPECIALTY` or `SPECIALTY_AUTH`. Max 255.
             * @example Cardiology
             */
            specialtyTargeting?: string;
            /**
             * @description Geographic targeting value. Required when `targetingType` is `GEO`, `SPECIALTY` or `SPECIALTY_AUTH`. Max 255.
             * @example US-CA,US-NY
             */
            geoTargeting?: string;
            /**
             * Format: uuid
             * @description UUID of the campaign owner user. Defaults to API key owner. Must belong to the caller's organization.
             * @example c3d4e5f6-a7b8-9012-cdef-123456789012
             */
            ownerUserId?: string;
            /**
             * @description ID of the team. To get this value, retrieve teams. Must belong to the caller's organization. Min 1.
             * @example 1
             */
            teamId?: number;
        };
        CheckCampaignRequestDuplicateResponseDto: {
            /**
             * @description Whether a campaign request with the given field value already exists in the organization.
             * @example true
             */
            exists: boolean;
        };
        /** @enum {number} */
        CampaignRequestViewEnum: CampaignRequestViewEnum;
        /**
         * @description The status of the campaign request
         * @enum {number}
         */
        CampaignRequestStatusEnum: CampaignRequestStatusEnum;
        CampaignRequestProgramSummaryDto: {
            /**
             * @description The ID of the linked program
             * @example 1
             */
            id: number;
            /**
             * @description The name of the linked program
             * @example Pharma Annual Program 2026
             */
            name: string;
        };
        CampaignRequestResponseDto: {
            /**
             * @description Campaign name
             * @example Summer Health Campaign 2026
             */
            campaignName: string;
            /**
             * @description Campaign pricing type. Defaults to `CPC`.
             * @default 0
             * @example 0
             */
            campaignType: components["schemas"]["CampaignTypeEnum"];
            /**
             * Format: date
             * @description Campaign's start date as an ISO 8601 calendar date (YYYY-MM-DD). No time component. Interpreted in the request's timezone. Must be in the future.
             * @example 2026-03-01
             */
            startDate?: string;
            /**
             * Format: date
             * @description Campaign's end date as an ISO 8601 calendar date (YYYY-MM-DD). No time component. Interpreted in the request's timezone. Must be after startDate.
             * @example 2026-06-30
             */
            endDate?: string;
            /**
             * @description IANA timezone name for interpreting startDate and endDate
             * @example America/New_York
             */
            timezone?: string;
            /**
             * @description Total campaign budget in USD cents. Min 1.
             * @example 500000
             */
            totalBudget?: number;
            /**
             * @description Cost in USD cents. Per click for CPC.
             * @example 300
             */
            cost?: number;
            /**
             * @description Budget distribution strategy. One of `EVENLY`, `FRONT_LOADED`, `MONTHLY`.
             * @example 0
             */
            distribution?: components["schemas"]["CampaignRequestDistributionEnum"];
            /**
             * @description Required and accepted only when distribution is MONTHLY. Must include all months between startDate and endDate.
             * @example {
             *       "2026-03": 150000,
             *       "2026-04": 175000,
             *       "2026-05": 175000
             *     }
             */
            monthlyBudget?: {
                [key: string]: number;
            };
            /**
             * @description ID of the campaign in the caller's system.
             * @example CAMP-2026-001
             */
            customId?: string;
            /**
             * @description 0 is the only acceptable value.
             * @example 0
             */
            creativeType?: components["schemas"]["CreativeTypeEnum"];
            /**
             * @description Targeting type for the campaign. One of `NPI`, `GEO`, `SPECIALTY`, `SPECIALTY_AUTH`, `RON`.
             * @example 0
             */
            targetingType?: components["schemas"]["CampaignRequestTargetingTypeEnum"];
            /**
             * @description Specialty targeting value. Required when `targetingType` is `SPECIALTY` or `SPECIALTY_AUTH`. Max 255.
             * @example Cardiology
             */
            specialtyTargeting?: string;
            /**
             * @description Geographic targeting value. Required when `targetingType` is `GEO`, `SPECIALTY` or `SPECIALTY_AUTH`. Max 255.
             * @example US-CA,US-NY
             */
            geoTargeting?: string;
            /**
             * @description The ID of the campaign request
             * @example 1
             */
            id: number;
            /**
             * @description The status of the campaign request
             * @example 0
             */
            status: components["schemas"]["CampaignRequestStatusEnum"];
            /** @description The team of the campaign request */
            team?: components["schemas"]["OrganizationTeamResponseDto"] | null;
            /** @description The content file of the campaign request */
            creativeFile?: components["schemas"]["CustomerFileResponseDto"] | null;
            /** @description The NPI file of the campaign request */
            npiFile?: components["schemas"]["CustomerFileResponseDto"] | null;
            /** @description The owner user of the campaign request */
            owner?: components["schemas"]["OrganizationUserResponseDto"] | null;
            /** @description The linked program of the campaign request */
            program?: components["schemas"]["CampaignRequestProgramSummaryDto"] | null;
            /** @description The created by user of the campaign request */
            createdByOrganizationUser?: components["schemas"]["OrganizationUserResponseDto"] | null;
            /** @description The created by API key of the campaign request */
            createdByApiKey?: components["schemas"]["OrganizationUserApiKeyResponseDto"] | null;
            /**
             * Format: date-time
             * @description The archived at date of the campaign request
             * @example 2026-12-31T23:59:59.000Z
             */
            archivedAt?: string | null;
            /**
             * Format: date-time
             * @description The created at date of the campaign request
             * @example 2026-01-15T10:30:00.000Z
             */
            createdAt: string;
            /**
             * Format: date-time
             * @description The updated at date of the campaign request
             * @example 2026-01-20T14:45:00.000Z
             */
            updatedAt: string;
            /**
             * @description Whether the campaign request has pending edits
             * @example false
             */
            hasPendingEdits: boolean;
            /**
             * @description The number of new comments on the campaign request
             * @example 0
             */
            numberOfNewComments: number;
            /** @description The click goal of the campaign request. Derived from totalBudget / cost when type is CPC; null otherwise. */
            clickGoal?: number | null;
            /**
             * @description The decline reason of the campaign request
             * @example Budget review pending for Q3
             */
            declineReason?: string;
        };
        /** @enum {number} */
        CampaignRequestEditStatusEnum: CampaignRequestEditStatusEnum;
        ManyCampaignRequestItemResponseDto: {
            /**
             * @description Campaign name
             * @example Summer Health Campaign 2026
             */
            campaignName: string;
            /**
             * @description Campaign pricing type. Defaults to `CPC`.
             * @default 0
             * @example 0
             */
            campaignType: components["schemas"]["CampaignTypeEnum"];
            /**
             * Format: date
             * @description Campaign's start date as an ISO 8601 calendar date (YYYY-MM-DD). No time component. Interpreted in the request's timezone. Must be in the future.
             * @example 2026-03-01
             */
            startDate?: string;
            /**
             * Format: date
             * @description Campaign's end date as an ISO 8601 calendar date (YYYY-MM-DD). No time component. Interpreted in the request's timezone. Must be after startDate.
             * @example 2026-06-30
             */
            endDate?: string;
            /**
             * @description IANA timezone name for interpreting startDate and endDate
             * @example America/New_York
             */
            timezone?: string;
            /**
             * @description Total campaign budget in USD cents. Min 1.
             * @example 500000
             */
            totalBudget?: number;
            /**
             * @description Cost in USD cents. Per click for CPC.
             * @example 300
             */
            cost?: number;
            /**
             * @description Budget distribution strategy. One of `EVENLY`, `FRONT_LOADED`, `MONTHLY`.
             * @example 0
             */
            distribution?: components["schemas"]["CampaignRequestDistributionEnum"];
            /**
             * @description ID of the campaign in the caller's system.
             * @example CAMP-2026-001
             */
            customId?: string;
            /**
             * @description Targeting type for the campaign. One of `NPI`, `GEO`, `SPECIALTY`, `SPECIALTY_AUTH`, `RON`.
             * @example 0
             */
            targetingType?: components["schemas"]["CampaignRequestTargetingTypeEnum"];
            /**
             * @description The ID of the campaign request
             * @example 1
             */
            id: number;
            /**
             * @description The status of the campaign request
             * @example 0
             */
            status: components["schemas"]["CampaignRequestStatusEnum"];
            /** @description The team of the campaign request */
            team?: components["schemas"]["OrganizationTeamResponseDto"] | null;
            /** @description The owner user of the campaign request */
            owner?: components["schemas"]["OrganizationUserResponseDto"] | null;
            /** @description The linked program of the campaign request */
            program?: components["schemas"]["CampaignRequestProgramSummaryDto"] | null;
            /**
             * Format: date-time
             * @description The created at date of the campaign request
             * @example 2026-01-15T10:30:00.000Z
             */
            createdAt: string;
            /**
             * Format: date-time
             * @description The updated at date of the campaign request
             * @example 2026-01-20T14:45:00.000Z
             */
            updatedAt: string;
            /**
             * @description Whether the campaign request has pending edits
             * @example false
             */
            hasPendingEdits: boolean;
            /**
             * @description The number of new comments on the campaign request
             * @example 0
             */
            numberOfNewComments: number;
            /** @description The click goal of the campaign request. Derived from totalBudget / cost when type is CPC; null otherwise. */
            clickGoal?: number | null;
        };
        ManyCampaignRequestsResponseDto: {
            /** @description Items */
            items: components["schemas"]["ManyCampaignRequestItemResponseDto"][];
            /**
             * @description Total count
             * @example 100
             */
            totalCount: number;
            /**
             * @description Has next page
             * @example true
             */
            hasNextPage: boolean;
            /**
             * @description Has previous page
             * @example true
             */
            hasPreviousPage: boolean;
            /**
             * @description Total pages
             * @example 10
             */
            totalPages: number;
        };
        CreateCampaignRequestProgramDto: {
            /**
             * @description Program name. Unique within the organization.
             * @example Pharma Annual Program 2026
             */
            name: string;
            /**
             * @description Agency name.
             * @example HealthMedia Agency
             */
            agency?: string;
            /**
             * Format: date
             * @description Program's start date as an ISO 8601 calendar date (YYYY-MM-DD). No time component. Interpreted in the program's timezone.
             * @example 2026-03-01
             */
            startDate: string;
            /**
             * Format: date
             * @description Program's end date as an ISO 8601 calendar date (YYYY-MM-DD). No time component. Interpreted in the program's timezone. Must be after startDate.
             * @example 2026-12-31
             */
            endDate: string;
            /**
             * @description IANA timezone name for interpreting startDate and endDate
             * @example America/New_York
             */
            timezone: string;
            /**
             * @description Cost in USD cents. Per click (CPC).
             * @example 300
             */
            cost: number;
            /**
             * @description Campaign pricing type. Defaults to `CPC`.
             * @default 0
             * @example 0
             */
            campaignType: components["schemas"]["CampaignTypeEnum"];
            /**
             * @description Total program budget in USD cents. Must equal the sum of monthly budgets. Min 1.
             * @example 1200000
             */
            totalBudget: number;
            /**
             * @description Monthly budget breakdown in USD cents, keyed by YYYY-MM. Must include only months between startDate and endDate and sum to totalBudget.
             * @example {
             *       "2026-03": 400000,
             *       "2026-04": 400000,
             *       "2026-05": 400000
             *     }
             */
            monthlyBudget: {
                [key: string]: number;
            };
            /**
             * @description Free-text targeting description.
             * @example Cardiologists in US-CA, US-NY
             */
            targeting?: string;
            /**
             * Format: uuid
             * @description UUID of the program owner user. Defaults to the logged-in user. Must belong to the caller's organization and have manage permission.
             * @example c3d4e5f6-a7b8-9012-cdef-123456789012
             */
            ownerUserId?: string;
        };
        CreateCampaignRequestProgramResponseDto: {
            /**
             * @description The ID of the program
             * @example 1
             */
            id: number;
        };
        /** @enum {number} */
        CampaignRequestProgramStageEnum: CampaignRequestProgramStageEnum;
        CampaignRequestProgramResponseDto: {
            /**
             * @description Program name. Unique within the organization.
             * @example Pharma Annual Program 2026
             */
            name: string;
            /**
             * @description Agency name.
             * @example HealthMedia Agency
             */
            agency?: string;
            /**
             * Format: date
             * @description Program's start date as an ISO 8601 calendar date (YYYY-MM-DD). No time component. Interpreted in the program's timezone.
             * @example 2026-03-01
             */
            startDate: string;
            /**
             * Format: date
             * @description Program's end date as an ISO 8601 calendar date (YYYY-MM-DD). No time component. Interpreted in the program's timezone. Must be after startDate.
             * @example 2026-12-31
             */
            endDate: string;
            /**
             * @description IANA timezone name for interpreting startDate and endDate
             * @example America/New_York
             */
            timezone: string;
            /**
             * @description Cost in USD cents. Per click (CPC).
             * @example 300
             */
            cost: number;
            /**
             * @description Campaign pricing type. Defaults to `CPC`.
             * @default 0
             * @example 0
             */
            campaignType: components["schemas"]["CampaignTypeEnum"];
            /**
             * @description Total program budget in USD cents. Must equal the sum of monthly budgets. Min 1.
             * @example 1200000
             */
            totalBudget: number;
            /**
             * @description Monthly budget breakdown in USD cents, keyed by YYYY-MM. Must include only months between startDate and endDate and sum to totalBudget.
             * @example {
             *       "2026-03": 400000,
             *       "2026-04": 400000,
             *       "2026-05": 400000
             *     }
             */
            monthlyBudget: {
                [key: string]: number;
            };
            /**
             * @description Free-text targeting description.
             * @example Cardiologists in US-CA, US-NY
             */
            targeting?: string;
            /**
             * @description The ID of the program
             * @example 1
             */
            id: number;
            /**
             * @description The stage of the program
             * @example 0
             */
            stage: components["schemas"]["CampaignRequestProgramStageEnum"];
            /**
             * @description The click goal of the program. Derived from totalBudget / cost.
             * @example 4000
             */
            clickGoal: number;
            /** @description The owner user of the program */
            owner?: components["schemas"]["OrganizationUserResponseDto"] | null;
            /** @description The organization user who created the program */
            createdByOrganizationUser?: components["schemas"]["OrganizationUserResponseDto"] | null;
            /**
             * @description List of stages the current actor may transition the program to
             * @example [
             *       1,
             *       3
             *     ]
             */
            stageTransitions: components["schemas"]["CampaignRequestProgramStageEnum"][];
            /**
             * Format: date-time
             * @description The created at date of the program
             * @example 2026-01-15T10:30:00.000Z
             */
            createdAt: string;
            /**
             * Format: date-time
             * @description The updated at date of the program
             * @example 2026-01-20T14:45:00.000Z
             */
            updatedAt: string;
        };
        ManyCampaignRequestProgramsResponseDto: {
            /** @description Items */
            items: components["schemas"]["CampaignRequestProgramResponseDto"][];
            /**
             * @description Total count
             * @example 100
             */
            totalCount: number;
            /**
             * @description Has next page
             * @example true
             */
            hasNextPage: boolean;
            /**
             * @description Has previous page
             * @example true
             */
            hasPreviousPage: boolean;
            /**
             * @description Total pages
             * @example 10
             */
            totalPages: number;
        };
        CheckCampaignRequestProgramDuplicateResponseDto: {
            /**
             * @description Whether a program with the given field value already exists in the organization.
             * @example true
             */
            exists: boolean;
        };
        UpdateCampaignRequestProgramDto: {
            /**
             * @description Program name. Unique within the organization.
             * @example Pharma Annual Program 2026
             */
            name?: string;
            /**
             * @description Agency name.
             * @example HealthMedia Agency
             */
            agency?: string;
            /**
             * Format: date
             * @description Program's start date as an ISO 8601 calendar date (YYYY-MM-DD). No time component. Interpreted in the program's timezone.
             * @example 2026-03-01
             */
            startDate?: string;
            /**
             * Format: date
             * @description Program's end date as an ISO 8601 calendar date (YYYY-MM-DD). No time component. Interpreted in the program's timezone. Must be after startDate.
             * @example 2026-12-31
             */
            endDate?: string;
            /**
             * @description IANA timezone name for interpreting startDate and endDate
             * @example America/New_York
             */
            timezone?: string;
            /**
             * @description Cost in USD cents. Per click (CPC).
             * @example 300
             */
            cost?: number;
            /**
             * @description Total program budget in USD cents. Must equal the sum of monthly budgets. Min 1.
             * @example 1200000
             */
            totalBudget?: number;
            /**
             * @description Monthly budget breakdown in USD cents, keyed by YYYY-MM. Must include only months between startDate and endDate and sum to totalBudget.
             * @example {
             *       "2026-03": 400000,
             *       "2026-04": 400000,
             *       "2026-05": 400000
             *     }
             */
            monthlyBudget?: {
                [key: string]: number;
            };
            /**
             * @description Free-text targeting description.
             * @example Cardiologists in US-CA, US-NY
             */
            targeting?: string;
            /**
             * Format: uuid
             * @description UUID of the program owner user. Defaults to the logged-in user. Must belong to the caller's organization and have manage permission.
             * @example c3d4e5f6-a7b8-9012-cdef-123456789012
             */
            ownerUserId?: string;
        };
        ChangeCampaignRequestProgramStageDto: {
            /**
             * @description The stage to transition the program to. Must be a valid transition for the current actor.
             * @example 1
             */
            stage: components["schemas"]["CampaignRequestProgramStageEnum"];
        };
        CampaignRequestEditDto: {
            /**
             * @description Whether to pause the campaign
             * @example false
             */
            pauseCampaign?: boolean;
            /**
             * @description The new total budget for the campaign
             * @example 600000
             */
            newTotalBudget?: number | null;
            /**
             * @description The new monthly budget for the campaign
             * @example {
             *       "2026-03": 200000,
             *       "2026-04": 200000,
             *       "2026-05": 200000
             *     }
             */
            newMonthlyBudget?: Record<string, never> | null;
            /**
             * @description The new end date for the campaign
             * @example 2026-09-30T23:59:59.000Z
             */
            newEndDate?: string | null;
            /**
             * @description The reason for the campaign edit required when pausing the campaign
             * @example Budget review pending for Q3
             */
            pauseCampaignReason?: string | null;
        };
        CreateCampaignRequestEditResponseDto: {
            /**
             * @description The ID of the campaign request edit
             * @example 1
             */
            id: number;
        };
        CampaignRequestEditResponseDto: {
            /**
             * @description Whether to pause the campaign
             * @example false
             */
            pauseCampaign?: boolean;
            /**
             * @description The new total budget for the campaign
             * @example 600000
             */
            newTotalBudget?: number | null;
            /**
             * @description The new monthly budget for the campaign
             * @example {
             *       "2026-03": 200000,
             *       "2026-04": 200000,
             *       "2026-05": 200000
             *     }
             */
            newMonthlyBudget?: {
                [key: string]: number;
            } | null;
            /**
             * Format: date-time
             * @description The new end date for the campaign
             * @example 2026-09-30T23:59:59.000Z
             */
            newEndDate?: string | null;
            /**
             * @description The reason for the campaign edit required when pausing the campaign
             * @example Budget review pending for Q3
             */
            pauseCampaignReason?: string | null;
            /**
             * @description The ID of the campaign request edit
             * @example 1
             */
            id: number;
            /**
             * @description The status of the campaign request edit
             * @example 0
             */
            status: components["schemas"]["CampaignRequestEditStatusEnum"];
            /**
             * @description Whether the campaign is paused
             * @example false
             */
            campaignStatusPaused?: boolean | null;
            /**
             * @description The original total budget of the campaign at the time of the edit
             * @example 600000
             */
            originalTotalBudget?: number | null;
            /**
             * @description The original monthly budget of the campaign at the time of the edit
             * @example {
             *       "2026-03": 200000,
             *       "2026-04": 200000,
             *       "2026-05": 200000
             *     }
             */
            originalMonthlyBudget?: {
                [key: string]: number;
            } | null;
            /**
             * Format: date-time
             * @description The original end date of the campaign at the time of the edit
             * @example 2026-09-30T23:59:59.000Z
             */
            originalEndDate?: string | null;
            /** @description The created by user of the campaign request edit */
            createdBy?: components["schemas"]["OrganizationUserResponseDto"] | null;
            /**
             * Format: date-time
             * @description The created at date of the campaign request edit
             * @example 2026-02-01T09:00:00.000Z
             */
            createdAt: string;
            /**
             * Format: date-time
             * @description The updated at date of the campaign request edit
             * @example 2026-02-05T11:30:00.000Z
             */
            updatedAt: string;
            /**
             * @description The decline reason of the campaign request edit
             * @example Budget review pending for Q3
             */
            declineReason?: string;
        };
        ManyCampaignRequestEditsResponseDto: {
            /** @description Items */
            items: components["schemas"]["CampaignRequestEditResponseDto"][];
            /**
             * @description Total count
             * @example 100
             */
            totalCount: number;
            /**
             * @description Has next page
             * @example true
             */
            hasNextPage: boolean;
            /**
             * @description Has previous page
             * @example true
             */
            hasPreviousPage: boolean;
            /**
             * @description Total pages
             * @example 10
             */
            totalPages: number;
        };
        CampaignRequestCommentReactionGroupDto: {
            /**
             * @description Emoji character
             * @example 👍
             */
            emoji: string;
            /**
             * @description Number of reactions with this emoji
             * @example 3
             */
            count: number;
            /**
             * @description Whether the current user has reacted with this emoji
             * @example true
             */
            hasReacted: boolean;
        };
        CampaignRequestCommentOrganizationUserMentionDto: {
            /**
             * @description The id of the user
             * @example c3d4e5f6-a7b8-9012-cdef-123456789012
             */
            id: string;
            /**
             * @description The email of the user
             * @example john.doe@example.com
             */
            email: string;
            /**
             * @description The role of the user
             * @example 0
             */
            role: components["schemas"]["OrganizationUserRoleEnum"];
            /**
             * @description The first name of the user
             * @example John
             */
            firstName?: string | null;
            /**
             * @description The last name of the user
             * @example Doe
             */
            lastName?: string | null;
            /**
             * @description The status of the user
             * @example 1
             */
            status: components["schemas"]["OrganizationUserStatusEnum"];
            /**
             * @description The next status of the user
             * @example 0
             */
            nextStatus: components["schemas"]["OrganizationUserStatusEnum"];
            /**
             * Format: date-time
             * @description The date the user last logged in
             * @example 2026-03-25T10:30:00.000Z
             */
            lastLoginAt?: string;
            /**
             * @description The created at date
             * @example 2026-01-01T00:00:00.000Z
             */
            createdAt: string;
            /**
             * @description The updated at date
             * @example 2026-01-15T10:30:00.000Z
             */
            updatedAt: string;
            /** @description The avatar of the user */
            avatar?: components["schemas"]["CustomerFileResponseDto"];
            /** @description Pending change request for this user */
            pendingChangeRequest: components["schemas"]["PendingOrganizationUserChangeRequestResponseDto"];
            /**
             * @description Number of mentions
             * @example 3
             */
            count: number;
        };
        CampaignRequestCommentUserMentionDto: {
            /**
             * @description User first name
             * @example Jane
             */
            firstName?: string | null;
            /**
             * @description User last name
             * @example Smith
             */
            lastName?: string | null;
            /**
             * @description User email
             * @example jane.smith@example.com
             */
            email: string;
            /**
             * @description User timezone
             * @example America/New_York
             */
            timezone?: string | null;
            /**
             * @description Number of mentions
             * @example 3
             */
            count: number;
        };
        CampaignRequestCommentReplyToDto: {
            /**
             * @description Campaign request comment id
             * @example 1
             */
            id: string;
            /**
             * @description Campaign request comment content
             * @example Please review the budget allocation for Q2.
             */
            comment: string;
            /**
             * Format: date-time
             * @description Campaign request comment created at
             * @example 2026-01-15T10:30:00.000Z
             */
            createdAt: string;
            /** @description Campaign request comment created by organization user */
            createdBy?: components["schemas"]["OrganizationUserResponseDto"];
            /** @description Campaign request comment created by internal user */
            createdByUser?: components["schemas"]["UserResponseDto"];
            /**
             * Format: date-time
             * @description Campaign request comment seen at
             * @example 2026-01-16T08:00:00.000Z
             */
            seenAt?: string | null;
            /** @description Mentioned organization users */
            mentionedOrganizationUsers?: components["schemas"]["CampaignRequestCommentOrganizationUserMentionDto"][];
            /** @description Mentioned internal users */
            mentionedUsers?: components["schemas"]["CampaignRequestCommentUserMentionDto"][];
        };
        CampaignRequestCommentResponseDto: {
            /**
             * @description Campaign request comment id
             * @example 1
             */
            id: string;
            /**
             * @description Campaign request comment content
             * @example Please review the budget allocation for Q2.
             */
            comment: string;
            /**
             * Format: date-time
             * @description Campaign request comment created at
             * @example 2026-01-15T10:30:00.000Z
             */
            createdAt: string;
            /** @description Campaign request comment created by organization user */
            createdBy?: components["schemas"]["OrganizationUserResponseDto"];
            /** @description Campaign request comment created by internal user */
            createdByUser?: components["schemas"]["UserResponseDto"];
            /**
             * Format: date-time
             * @description Campaign request comment seen at
             * @example 2026-01-16T08:00:00.000Z
             */
            seenAt?: string | null;
            /** @description Reactions grouped by emoji */
            reactions: components["schemas"]["CampaignRequestCommentReactionGroupDto"][];
            /** @description Campaign request comment reply to */
            replyTo?: components["schemas"]["CampaignRequestCommentReplyToDto"];
            /** @description Campaign request comment mentioned organization users */
            mentionedOrganizationUsers?: components["schemas"]["CampaignRequestCommentOrganizationUserMentionDto"][];
            /** @description Campaign request comment mentioned users */
            mentionedUsers?: components["schemas"]["CampaignRequestCommentUserMentionDto"][];
        };
        ManyCampaignRequestCommentsResponseDto: {
            /** @description Items */
            items: components["schemas"]["CampaignRequestCommentResponseDto"][];
            /**
             * @description Total count
             * @example 100
             */
            totalCount: number;
            /**
             * @description Has next page
             * @example true
             */
            hasNextPage: boolean;
            /**
             * @description Has previous page
             * @example true
             */
            hasPreviousPage: boolean;
            /**
             * @description Total pages
             * @example 10
             */
            totalPages: number;
        };
        CreateCampaignRequestCommentDto: {
            /**
             * @description Campaign request comment content
             * @example Please review the budget allocation for Q2.
             */
            comment: string;
            /**
             * @description Campaign request comment reply to id
             * @example 123e4567-e89b-12d3-a456-426614174000
             */
            replyToId?: string;
            /**
             * @description Campaign request comment mentioned organization user ids
             * @example [
             *       1,
             *       2,
             *       3
             *     ]
             */
            mentionedOrganizationUserIds?: string[];
            /**
             * @description Campaign request comment mentioned user emails
             * @example [
             *       "john.doe@example.com",
             *       "jane.doe@example.com"
             *     ]
             */
            mentionedUserEmails?: string[];
        };
        ReportTypeResponseDto: {
            /** @description Report type */
            type: string;
            /** @description Report name */
            name: string;
        };
        /** @enum {number} */
        ReportEntityTypeEnum: ReportEntityTypeEnum;
        /**
         * @description Report date range type
         * @enum {string}
         */
        ReportDateRangeTypeEnum: ReportDateRangeTypeEnum;
        ReportResponseDto: {
            /**
             * @description Report date range type
             * @example year
             */
            dateRangeType: components["schemas"]["ReportDateRangeTypeEnum"];
            /**
             * @description Report date range start
             * @example 2026-01-01
             */
            dateRangeStart: string;
            /**
             * @description Report date range end
             * @example 2026-01-01
             */
            dateRangeEnd: string;
            /**
             * @description CSV report file name
             * @example 2026-01-01_2026-03-31.csv
             */
            csvFileName: string;
            /**
             * @description XLSX report file name
             * @example 2026-01-01_2026-03-31.xlsx
             */
            xlsxFileName?: string | null;
            /**
             * @description Report entity type
             * @example 1
             */
            entityType: components["schemas"]["ReportEntityTypeEnum"];
        };
        ValidatePasswordStrengthDto: {
            /**
             * @description Password to validate strength
             * @example MyS3cur3P@ss
             */
            password: string;
        };
        /**
         * @description Password strength score
         * @enum {number}
         */
        PasswordStrengthScoreEnum: PasswordStrengthScoreEnum;
        PasswordStrengthResponseDto: {
            /**
             * @description Password strength score
             * @example 3
             */
            score: components["schemas"]["PasswordStrengthScoreEnum"];
            /**
             * @description Warning message explaining why the password is weak
             * @example This is a top-10 common password
             */
            warning: string;
            /**
             * @description Suggestions to improve password strength
             * @example [
             *       "Add another word or two. Uncommon words are better."
             *     ]
             */
            suggestions: string[];
        };
        /** @enum {number} */
        CustomerAuditLogEntityTypeEnum: CustomerAuditLogEntityTypeEnum;
        /** @enum {number} */
        CustomerAuditLogActionEnum: CustomerAuditLogActionEnum;
        CustomerAuditLogCreatedByUserResponseDto: {
            /**
             * @description User first name
             * @example Jane
             */
            firstName?: string | null;
            /**
             * @description User last name
             * @example Smith
             */
            lastName?: string | null;
        };
        /**
         * @description The type of actor that performed the action
         * @enum {string}
         */
        ActorTypeEnum: ActorTypeEnum;
        CustomerAuditLogResponseDto: {
            /** @description The unique identifier of the audit log entry */
            id: number;
            /** @description The action performed */
            action: components["schemas"]["CustomerAuditLogActionEnum"];
            /** @description The type of entity that was affected */
            entityType: components["schemas"]["CustomerAuditLogEntityTypeEnum"];
            /** @description Human-readable description of the change */
            description: string;
            /**
             * @description Date and time the log was created (ISO 8601)
             * @example 2024-01-01T00:00:00.000Z
             */
            createdAt: string;
            /** @description The user who performed the action */
            createdByUser?: components["schemas"]["CustomerAuditLogCreatedByUserResponseDto"];
            /** @description The API key used to perform the action */
            createdByApiKey?: components["schemas"]["OrganizationUserApiKeyResponseDto"];
            /** @description The organization user who performed the action */
            createdByOrganizationUser?: components["schemas"]["OrganizationUserResponseDto"];
            /** @description The type of actor that performed the action */
            actorType: components["schemas"]["ActorTypeEnum"];
        };
        ManyCustomerAuditLogsResponseDto: {
            /** @description Items */
            items: components["schemas"]["CustomerAuditLogResponseDto"][];
            /**
             * @description Total count
             * @example 100
             */
            totalCount: number;
            /**
             * @description Has next page
             * @example true
             */
            hasNextPage: boolean;
            /**
             * @description Has previous page
             * @example true
             */
            hasPreviousPage: boolean;
            /**
             * @description Total pages
             * @example 10
             */
            totalPages: number;
        };
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
    OrganizationUserApiKeyController_getMany: {
        parameters: {
            query?: {
                /** @description Limit */
                limit?: number;
                /** @description Page */
                page?: number;
                /** @description Order by field */
                sortBy?: string[];
                /** @description The name of the API key to filter by */
                name?: string;
                /** @description Filter by API key status */
                status?: components["schemas"]["OrganizationUserApiKeyStatusEnum"][];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description API keys retrieved successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ManyOrganizationUserApiKeysResponseDto"];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    OrganizationUserApiKeyController_create: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateOrganizationUserApiKeyDto"];
            };
        };
        responses: {
            /** @description API key created successfully */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OrganizationUserApiKeyResponseDto"];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    OrganizationUserApiKeyController_update: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The API key */
                apiKey: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateOrganizationUserApiKeyDto"];
            };
        };
        responses: {
            /** @description API key updated successfully */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    OrganizationUserApiKeyController_downloadApiKeyIntegrationSchema: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description The file */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": components["schemas"]["StreamableFile"];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    OrganizationUserInvitationController_getMany: {
        parameters: {
            query?: {
                /** @description Limit */
                limit?: number;
                /** @description Page */
                page?: number;
                /** @description Order by field */
                sortBy?: string[];
                /** @description Filter by invitation status */
                status?: components["schemas"]["OrganizationUserInvitationStatusEnum"][];
                /** @description Filter by invited email (partial match) */
                email?: string;
                /** @description Filter by expiry — true returns only expired invitations, false returns non-expired */
                isExpired?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Organization user invitations retrieved successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ManyOrganizationUserInvitationsResponseDto"];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    OrganizationUserInvitationController_create: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateOrganizationUserInvitationDto"];
            };
        };
        responses: {
            /** @description Invitation created and email sent. */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OrganizationUserInvitationResponseDto"];
                };
            };
            /** @description Invitation pending approval. */
            202: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OrganizationUserInvitationResponseDto"];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    OrganizationUserInvitationController_cancel: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The UUID of the invitation */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Organization user invitation cancelled successfully */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    OrganizationUserInvitationController_resend: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The UUID of the invitation */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Organization user invitation resent successfully */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    OrganizationUserInvitationController_validate: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The UUID token of the invitation */
                token: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Invitation token validated successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ValidateOrganizationUserInvitationResponseDto"];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    OrganizationUserInvitationController_accept: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The UUID token of the invitation */
                token: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AcceptOrganizationUserInvitationDto"];
            };
        };
        responses: {
            /** @description Organization invitation accepted successfully */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    OrganizationTeamController_getMany: {
        parameters: {
            query?: {
                /** @description Limit */
                limit?: number;
                /** @description Page */
                page?: number;
                /** @description Order by field */
                sortBy?: string[];
                /** @description Team name */
                name?: string;
                /** @description Team ID */
                id?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Organization teams retrieved successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ManyOrganizationTeamsResponseDto"];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    OrganizationTeamController_create: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateOrganizationTeamDto"];
            };
        };
        responses: {
            /** @description Organization team created successfully */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CreateOrganizationTeamResponseDto"];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    OrganizationTeamController_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The id of the organization team */
                id: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Organization team retrieved successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OrganizationTeamResponseDto"];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    OrganizationTeamController_delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The id of the organization team */
                id: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Organization team deleted successfully */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    OrganizationTeamController_update: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The id of the organization team */
                id: number;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateOrganizationTeamDto"];
            };
        };
        responses: {
            /** @description Organization team updated successfully */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    OrganizationUserController_getMany: {
        parameters: {
            query?: {
                /** @description Limit */
                limit?: number;
                /** @description Page */
                page?: number;
                /** @description Order by field */
                sortBy?: string[];
                /** @description search by email */
                email?: string;
                /** @description filter by user id */
                id?: string;
                /** @description Filter by role */
                role?: components["schemas"]["OrganizationUserRoleEnum"][];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Organization users retrieved successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ManyOrganizationUsersResponseDto"];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    OrganizationUserController_update: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The UUID of the organization user */
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateOrganizationUserDto"];
            };
        };
        responses: {
            /** @description Organization user updated successfully. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UpdateOrganizationUserResponseDto"];
                };
            };
            /** @description Change request created pending approval. */
            202: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UpdateOrganizationUserResponseDto"];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    OrganizationUserChangeRequestController_getMany: {
        parameters: {
            query?: {
                /** @description Limit */
                limit?: number;
                /** @description Page */
                page?: number;
                /** @description Order by field */
                sortBy?: string[];
                /** @description Filter by change request status */
                status?: components["schemas"]["OrganizationUserChangeRequestStatusEnum"];
                /** @description Filter by change request type */
                type?: components["schemas"]["OrganizationUserChangeRequestTypeEnum"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Organization user change requests retrieved successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ManyOrganizationUserChangeRequestsResponseDto"];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    MeController_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description The user info retrieved successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["MeResponseDto"];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    MeController_update: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateMeDto"];
            };
        };
        responses: {
            /** @description The user info updated successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["MeResponseDto"];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    MeController_login: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Login recorded successfully */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    OrganizationController_get: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description The organization info retrieved successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OrganizationResponseDto"];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    CustomerFileController_upload: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The type of the file */
                type: components["schemas"]["CustomerFileTypeEnum"];
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["UploadFileDto"];
            };
        };
        responses: {
            /** @description The file uploaded successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CustomerFileResponseDto"];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    CampaignRequestController_submit: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The id of the campaign request to submit */
                id: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Campaign request submitted to review successfully */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    CampaignRequestController_archive: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The id of the campaign request to archive */
                id: number;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ArchiveCampaignRequestDto"];
            };
        };
        responses: {
            /** @description Campaign request archived successfully */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    CampaignRequestController_getMany: {
        parameters: {
            query?: {
                /** @description Filter by view */
                view?: components["schemas"]["CampaignRequestViewEnum"];
                /** @description Limit */
                limit?: number;
                /** @description Page */
                page?: number;
                /** @description Order by field */
                sortBy?: string[];
                /** @description Filter by campaign name */
                campaignName?: string;
                /** @description Filter by status */
                status?: components["schemas"]["CampaignRequestStatusEnum"];
                /** @description Filter by campaign request ID */
                id?: number;
                /** @description Filter by the customer-specific ID of the linked program */
                programId?: number;
                /** @description Filter by edit request status */
                editRequestStatus?: components["schemas"]["CampaignRequestEditStatusEnum"];
                /** @description Filter by start date greater than or equal to */
                startDateGte?: string;
                /** @description Filter by start date less than or equal to */
                startDateLte?: string;
                /** @description Filter by end date greater than or equal to */
                endDateGte?: string;
                /** @description Filter by end date less than or equal to */
                endDateLte?: string;
                /** @description Filter by total budget greater than or equal to */
                totalBudgetGte?: number;
                /** @description Filter by total budget less than or equal to */
                totalBudgetLte?: number;
                /** @description Filter by owner ID */
                ownerId?: number;
                /** @description Filter by team ID */
                teamId?: number;
                /** @description Filter by creative type */
                creativeType?: components["schemas"]["CreativeTypeEnum"];
                /** @description Filter by targeting type */
                targetingType?: components["schemas"]["CampaignRequestTargetingTypeEnum"];
                /** @description Filter by whether the campaign request has pending edits */
                hasPendingEdits?: boolean;
                /** @description Filter by whether the campaign request has pending comments */
                hasNewComments?: boolean;
                /** @description Filter by whether the campaign request is archived */
                archived?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Campaign requests retrieved successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ManyCampaignRequestsResponseDto"];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    CampaignRequestController_create: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateCampaignRequestDto"];
            };
        };
        responses: {
            /** @description Campaign request created successfully */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CreateCampaignRequestResponseDto"];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    CampaignRequestController_get: {
        parameters: {
            query?: {
                /** @description Filter by view */
                view?: components["schemas"]["CampaignRequestViewEnum"];
            };
            header?: never;
            path: {
                /** @description The customer-specific ID of the campaign request */
                id: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Campaign request retrieved successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CampaignRequestResponseDto"];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    CampaignRequestController_update: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The customer-specific ID of the campaign request */
                id: number;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateCampaignRequestDto"];
            };
        };
        responses: {
            /** @description Campaign request updated successfully */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    CampaignRequestController_checkDuplicate: {
        parameters: {
            query: {
                /**
                 * @description The campaign request field to check for duplicates within the organization.
                 * @example campaignName
                 * @example customId
                 */
                field: string;
                /** @description The value to check for an existing campaign request. */
                value: string;
                /** @description The customerSpecificId of the campaign request being edited, excluded from the check. */
                excludeId?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Duplicate check completed successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CheckCampaignRequestDuplicateResponseDto"];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    CampaignRequestProgramController_getMany: {
        parameters: {
            query?: {
                /** @description Limit */
                limit?: number;
                /** @description Page */
                page?: number;
                /** @description Order by field */
                sortBy?: string[];
                /** @description Filter by program IDs */
                id?: number[];
                /** @description Filter by program name */
                name?: string;
                /** @description Filter by owner ID */
                ownerId?: string;
                /** @description Filter by stage */
                stage?: components["schemas"]["CampaignRequestProgramStageEnum"];
                /** @description Filter by start date greater than or equal to */
                startDateGte?: string;
                /** @description Filter by end date less than or equal to */
                endDateLte?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Programs retrieved successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ManyCampaignRequestProgramsResponseDto"];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    CampaignRequestProgramController_create: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateCampaignRequestProgramDto"];
            };
        };
        responses: {
            /** @description The program has been successfully created */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CreateCampaignRequestProgramResponseDto"];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    CampaignRequestProgramController_checkDuplicate: {
        parameters: {
            query: {
                /**
                 * @description The program field to check for duplicates within the organization.
                 * @example name
                 */
                field: string;
                /** @description The value to check for an existing program. */
                value: string;
                /** @description The customerSpecificId of the program being edited, excluded from the check. */
                excludeId?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Duplicate check performed successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CheckCampaignRequestProgramDuplicateResponseDto"];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    CampaignRequestProgramController_getOne: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the program */
                id: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Program retrieved successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CampaignRequestProgramResponseDto"];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    CampaignRequestProgramController_update: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the program */
                id: number;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateCampaignRequestProgramDto"];
            };
        };
        responses: {
            /** @description The program has been successfully updated */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    CampaignRequestProgramController_changeStage: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the program */
                id: number;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ChangeCampaignRequestProgramStageDto"];
            };
        };
        responses: {
            /** @description The program stage has been successfully changed */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    CampaignRequestProgramController_linkCampaignRequest: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the program */
                id: number;
                /** @description The ID of the campaign request */
                campaignRequestId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description The campaign request has been successfully linked */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    CampaignRequestProgramController_unlinkCampaignRequest: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the program */
                id: number;
                /** @description The ID of the campaign request */
                campaignRequestId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description The campaign request has been successfully unlinked */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    CampaignRequestEditController_getMany: {
        parameters: {
            query?: {
                /** @description Limit */
                limit?: number;
                /** @description Page */
                page?: number;
                /** @description Order by field */
                sortBy?: string[];
                /** @description Filter by status */
                status?: components["schemas"]["CampaignRequestEditStatusEnum"];
                /** @description Filter by pause campaign reason */
                pauseCampaignReason?: string;
            };
            header?: never;
            path: {
                /** @description The ID of the campaign request */
                id: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Campaign request edits retrieved successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ManyCampaignRequestEditsResponseDto"];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    CampaignRequestEditController_create: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the campaign request */
                id: number;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CampaignRequestEditDto"];
            };
        };
        responses: {
            /** @description Campaign request edit created successfully */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CreateCampaignRequestEditResponseDto"];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    CampaignRequestEditController_get: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the campaign request edit */
                id: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Campaign request edit retrieved successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CampaignRequestEditResponseDto"];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    CampaignRequestEditController_update: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the campaign request edit */
                id: number;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CampaignRequestEditDto"];
            };
        };
        responses: {
            /** @description Campaign request edit updated successfully */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    CampaignRequestEditController_cancel: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the campaign request edit */
                id: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Campaign request edit cancelled successfully */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    CampaignRequestCommentController_getMany: {
        parameters: {
            query?: {
                /** @description Limit */
                limit?: number;
                /** @description Page */
                page?: number;
                /** @description Order by field */
                sortBy?: string[];
            };
            header?: never;
            path: {
                /** @description The ID of the campaign request */
                id: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Campaign request comments retrieved successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ManyCampaignRequestCommentsResponseDto"];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    CampaignRequestCommentController_create: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the campaign request */
                id: number;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateCampaignRequestCommentDto"];
            };
        };
        responses: {
            /** @description Campaign request comment created successfully */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    CampaignRequestCommentController_open: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the campaign request */
                id: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Campaign request comments opened successfully */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    CampaignRequestCommentReactionController_react: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the campaign request comment */
                commentId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Campaign request comment reaction toggled successfully */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    ReportController_getManyTypes: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Organization reports retrieved successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ReportTypeResponseDto"][];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    ReportController_download: {
        parameters: {
            query: {
                /** @description Report type */
                type: string;
                /** @description Report entity type */
                entityType: components["schemas"]["ReportEntityTypeEnum"];
                /** @description Report file name */
                fileName: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Report downloaded successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": components["schemas"]["StreamableFile"];
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": components["schemas"]["StreamableFile"];
                    "text/csv": components["schemas"]["StreamableFile"];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    ReportController_getMany: {
        parameters: {
            query: {
                /** @description Report type */
                type: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Organization reports retrieved successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ReportResponseDto"][];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    PasswordStrengthController_validate: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ValidatePasswordStrengthDto"];
            };
        };
        responses: {
            /** @description Password strength validated successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PasswordStrengthResponseDto"];
                };
            };
        };
    };
    CustomerAuditLogController_getMany: {
        parameters: {
            query?: {
                /** @description Limit */
                limit?: number;
                /** @description Page */
                page?: number;
                /** @description Filter by entity type */
                entityTypes?: components["schemas"]["CustomerAuditLogEntityTypeEnum"];
                /** @description Filter by action */
                actions?: components["schemas"]["CustomerAuditLogActionEnum"];
                /** @description Filter by acting organization user (customerSpecificId) */
                organizationUserId?: string;
                /** @description Filter logs created at or after this date (ISO 8601) */
                createdAtGte?: string;
                /** @description Filter logs created at or before this date (ISO 8601) */
                createdAtLte?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Audit logs retrieved successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ManyCustomerAuditLogsResponseDto"];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    CustomerAuditLogController_getCampaignRequestAuditLogs: {
        parameters: {
            query?: {
                /** @description Limit */
                limit?: number;
                /** @description Page */
                page?: number;
                /** @description Filter logs created at or after this date (ISO 8601) */
                createdAtGte?: string;
                /** @description Filter logs created at or before this date (ISO 8601) */
                createdAtLte?: string;
            };
            header?: never;
            path: {
                /** @description The customer-specific ID of the campaign request */
                id: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Audit logs retrieved successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ManyCustomerAuditLogsResponseDto"];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
    CustomerAuditLogController_getCampaignRequestProgramAuditLogs: {
        parameters: {
            query?: {
                /** @description Limit */
                limit?: number;
                /** @description Page */
                page?: number;
                /** @description Filter logs created at or after this date (ISO 8601) */
                createdAtGte?: string;
                /** @description Filter logs created at or before this date (ISO 8601) */
                createdAtLte?: string;
            };
            header?: never;
            path: {
                /** @description The customer-specific ID of the program */
                id: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Audit logs retrieved successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ManyCustomerAuditLogsResponseDto"];
                };
            };
            /** @description BadRequestException */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description UnauthorizedException */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ForbiddenException */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description NotFoundException */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description InternalServerErrorException */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description ServiceUnavailableException */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
            /** @description GatewayTimeoutException */
            504: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ApiErrorDto"];
                };
            };
        };
    };
}
export enum OrganizationUserApiKeyStatusEnum {
    Value1 = 1,
    Value0 = 0
}
export enum UpdateOrganizationUserApiKeyDtoStatus {
    Value1 = 1,
    Value0 = 0
}
export enum OrganizationUserInvitationStatusEnum {
    PENDING = 0,
    ACCEPTED = 1,
    CANCELLED = 2,
    PENDING_APPROVAL = 3
}
export enum OrganizationUserRoleEnum {
    ADMIN = 0,
    EDITOR = 1,
    VIEWER = 2
}
export enum OrganizationUserStatusEnum {
    Value1 = 1,
    Value0 = 0
}
export enum CustomerFileTypeEnum {
    LINK = 0,
    NPI = 1,
    AVATAR = 2
}
export enum OrganizationUserChangeRequestTypeEnum {
    INVITE_ADMIN = 0,
    CHANGE_ROLE = 1,
    DEACTIVATE = 2
}
export enum OrganizationUserChangeRequestStatusEnum {
    PENDING = 0,
    APPROVED = 1,
    DECLINED = 2
}
export enum CustomerPermissionActionEnum {
    CREATE = "create",
    READ = "read",
    UPDATE = "update",
    DELETE = "delete",
    MANAGE = "manage"
}
export enum CustomerPermissionSubjectEnum {
    CAMPAIGN_REQUEST = "campaignRequest",
    CAMPAIGN_REQUEST_EDIT = "campaignRequestEdit",
    ORGANIZATION_USER = "organizationUser",
    ORGANIZATION_TEAM = "organizationTeam",
    ORGANIZATION_USER_INVITATION = "organizationUserInvitation",
    CUSTOMER_FILE = "customerFile",
    CAMPAIGN_REQUEST_COMMENT = "campaignRequestComment",
    ORGANIZATION_USER_API_KEY = "organizationUserApiKey",
    REPORT = "report",
    ORGANIZATION_USER_CHANGE_REQUEST = "organizationUserChangeRequest",
    CUSTOMER_AUDIT_LOG = "customerAuditLog",
    ALL = "all"
}
export enum FeatureEnum {
    CAMPAIGN_REQUEST_PROGRAM = "campaignRequestProgram"
}
export enum OrganizationAccessControlModuleEnum {
    CAMPAIGN_REQUEST = 0,
    REPORTING = 1,
    API_KEY_INTEGRATION = 2,
    INVOICING = 3,
    PAYMENT = 4,
    CONTRACT = 5
}
export enum CampaignTypeEnum {
    CPC = 0,
    CPM = 1
}
export enum CampaignRequestDistributionEnum {
    EVENLY = 0,
    FRONT_LOADED = 1,
    MONTHLY = 2
}
export enum CreativeTypeEnum {
    LINK = 0
}
export enum CampaignRequestTargetingTypeEnum {
    NPI = 0,
    GEO = 1,
    SPECIALTY = 2,
    SPECIALTY_AUTH = 3,
    RON = 4
}
export enum CampaignRequestViewEnum {
    EFFECTIVE = 0,
    CONTRACT = 1
}
export enum CampaignRequestStatusEnum {
    DRAFT = 0,
    IN_REVIEW = 1,
    PROCESSING = 2,
    DECLINED = 3,
    ACTIVE = 4,
    PAUSED = 5,
    ENDED = 6,
    COMPLETED = 7
}
export enum CampaignRequestEditStatusEnum {
    IN_REVIEW = 0,
    DECLINED = 2,
    APPROVED = 3,
    CANCELLED = 4
}
export enum CampaignRequestProgramStageEnum {
    NEGOTIATING = 0,
    CONFIRMED = 1,
    READY_FOR_LAUNCH = 2,
    LOST = 3,
    LIVE = 4,
    PAUSED = 5,
    COMPLETED = 6
}
export enum ReportEntityTypeEnum {
    ORGANIZATION = 1,
    CAMPAIGN = 2,
    AD_SET = 3,
    AD_SLOT = 4,
    PUBLICATION_URL = 5
}
export enum ReportDateRangeTypeEnum {
    YEAR = "year",
    DAY = "day",
    RANGE = "range"
}
export enum PasswordStrengthScoreEnum {
    TOO_GUESSABLE = 0,
    VERY_GUESSABLE = 1,
    SOMEWHAT_GUESSABLE = 2,
    SAFELY_UNGUESSABLE = 3,
    VERY_UNGUESSABLE = 4
}
export enum CustomerAuditLogEntityTypeEnum {
    ORGANIZATION_USER = 0,
    CAMPAIGN_REQUEST = 1,
    CAMPAIGN_REQUEST_EDIT = 2,
    ORGANIZATION_USER_API_KEY = 3,
    ORGANIZATION_USER_INVITATION = 4,
    ORGANIZATION_TEAM = 5,
    ORGANIZATION_USER_CHANGE_REQUEST = 6,
    CAMPAIGN_REQUEST_COMMENT = 7,
    CUSTOMER_FILE = 8,
    CAMPAIGN_REQUEST_PROGRAM = 9
}
export enum CustomerAuditLogActionEnum {
    CREATE = 0,
    UPDATE = 1,
    DELETE = 2,
    ORGANIZATION_USER_LOGIN = 3,
    ORGANIZATION_USER_INVITATION_RESEND = 5,
    ORGANIZATION_USER_INVITATION_CANCEL = 6,
    CAMPAIGN_REQUEST_ARCHIVE = 7,
    CAMPAIGN_REQUEST_UNARCHIVE = 8,
    CAMPAIGN_REQUEST_SUBMIT = 9,
    STATE_CHANGE = 10,
    ORGANIZATION_USER_DEACTIVATE = 11,
    CAMPAIGN_REQUEST_PROGRAM_LINK = 12,
    CAMPAIGN_REQUEST_PROGRAM_UNLINK = 13
}
export enum ActorTypeEnum {
    USER = "USER",
    ORGANIZATION_USER = "ORGANIZATION_USER",
    SYSTEM = "SYSTEM"
}
